import styled from "styled-components";

export const Container = styled.div`
  padding: 20px;
  background: linear-gradient(135deg, #f5f9fc 0%, #ffffff 100%);
  min-height: 100vh;
  
  @media screen and (max-width: 568px) {
    .heading {
      flex-direction: column;
      gap: 20px;
      
      h1 {
        font-size: 24px;
      }
    }
  }
  
  .link-buttons {
    display: flex;
    gap: 12px;
    align-items: center;
    
    .see-more,
    .add-campaign {
      padding: 10px 20px;
      height: 42px;
      border-radius: 10px;
      font-size: 14px;
      font-weight: 500;
      background-color: transparent;
      text-decoration: none;
      cursor: pointer;
      transition: all 0.3s ease;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #03a9f4;
      border: 2px solid #03a9f4;
    }
    
    .add-campaign {
      color: #fff;
      background: linear-gradient(135deg, #03a9f4 0%, #0288d1 100%);
      box-shadow: 0 2px 8px rgba(3, 169, 244, 0.3);
      
      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 16px rgba(3, 169, 244, 0.4);
      }
    }
  }
  
  .heading {
    margin-bottom: 40px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding-bottom: 20px;
    border-bottom: 2px solid #e3f2fd;
    
    h1 {
      font-size: 36px;
      line-height: 48px;
      color: #1a237e;
      font-weight: 700;
      margin-bottom: 8px;
      background: linear-gradient(135deg, #03a9f4 0%, #0288d1 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
    }
    
    p {
      font-size: 16px;
      line-height: 24px;
      color: #546881;
    }
  }

  h4 {
    font-size: 20px;
    color: #1a237e;
    line-height: 28px;
    font-weight: 600;
    margin: 40px 0 20px 0;
    padding-left: 12px;
    border-left: 4px solid #03a9f4;
  }
  
  hr {
    margin-top: 30px;
    margin-bottom: 30px;
    border: none;
    border-bottom: 2px solid #e3f2fd;
  }
`;

export const Details = styled.div`
  margin-top: 20px;
  width: 100%;
  max-width: 900px;
  padding: 30px;
  background: #ffffff;
  border: 2px solid #e3f2fd;
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(3, 169, 244, 0.08);
  transition: all 0.3s ease;
  
  &:hover {
    box-shadow: 0 4px 16px rgba(3, 169, 244, 0.12);
  }

  .wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 0;
    border-bottom: 1px solid #e3f2fd;
    
    &:last-child {
      border-bottom: none;
    }
    
    &:first-child {
      padding-top: 0;
    }

    label {
      font-size: 13px;
      color: #546881;
      line-height: 20px;
      font-weight: 500;
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }

    p {
      font-size: 15px;
      color: #1a237e;
      line-height: 22px;
      font-weight: 600;
      text-align: right;
      margin: 0;
    }
    
    a {
      font-size: 15px;
      color: #03a9f4;
      line-height: 22px;
      text-decoration: none;
      font-weight: 500;
      text-align: right;
      word-break: break-all;
      transition: all 0.3s ease;
      
      &:hover {
        color: #0288d1;
        text-decoration: underline;
      }
    }
    
    .url {
      display: flex;
      justify-content: flex-end;
      width: 60%;
      text-align: right;
    }
  }
  
  @media screen and (max-width: 568px) {
    width: 100%;
    padding: 20px;
    
    .wrapper {
      flex-direction: column;
      align-items: flex-start;
      gap: 8px;
      
      p, a {
        text-align: left;
        width: 100%;
      }
      
      .url {
        width: 100%;
        justify-content: flex-start;
      }
    }
  }
`;
